// this is an autogenerated file from DesignSystem/TasksViewForm/mutation-generate-letter.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksViewForm(
  $patient_id: uuid!
  $document_template_id: uuid!
  $recipient_id: uuid
  $postal_address_id: uuid
  $appointment_id: Int
  $booking_id: Int
  $tooth_chart_snapshot_id: Int
  $tooth_marking_ids: [Int!]
) {
  tasks_generate_letter(
    document_template_id: $document_template_id
    patient_id: $patient_id
    recipient_id: $recipient_id
    postal_address_id: $postal_address_id
    appointment_id: $appointment_id
    booking_id: $booking_id
    tooth_chart_snapshot_id: $tooth_chart_snapshot_id
    tooth_marking_ids: $tooth_marking_ids
  ) {
    documentNodeId
  }
}

`